<template>
  <div class="appoint-map">
    <img
      class="refresh"
      src="@/assets/weather/refresh.png"
      alt=""
      @click="refresh"
    />
    <div class="position-long">相距：{{ long }}</div>
    <el-amap
      ref="map"
      vid="amapDemo"
      rotateEnable
      resizeEnable
      expandZoomRange
      :zoom="zoom"
      :center="center"
      :plugin="plugin"
    >
      <el-amap-marker
        v-for="marker in markers"
        :key="marker.label"
        :position="marker.position"
        :events="marker.events"
        :icon="marker.image"
        :label="marker.label"
      >
      </el-amap-marker>
      <el-amap-polyline
        :path="polyline.path"
        :strokeWeight="polyline.strokeWeight"
        :strokeColor="polyline.strokeColor"
      ></el-amap-polyline>
    </el-amap>
  </div>
</template>

<script>
import { getAppointMap } from "@/api/oilAppoint";
export default {
  data() {
    return {
      center: [122.138247, 29.812997],
      long: 0,
      markers: [],
      polyline: {
        path: [],
        strokeColor: "#2476D1",
        strokeWeight: 5
      },
      zoom: 6,
      plugin: [
        "ToolBar",
        {
          pName: "MapType",
          //1为卫星图 0为默认
          defaultType: 1,
          //showRoad和showTraffic 为路况和路网
          showRoad: true
        },
        {
          pName: "Scale"
        }
      ]
    };
  },
  mounted() {
    const { id } = this.$route.params;
    this.id = id;
    this.getData(id);
  },
  methods: {
    getData(id) {
      getAppointMap({ id })
        .then(res => {
          const list = res;
          const that = this;
          this.center = [
            (parseFloat(list[0].longitude) + parseFloat(list[1].longitude)) / 2,
            (parseFloat(list[0].latitude) + parseFloat(list[1].latitude)) / 2
          ];
          this.long = this.getdiscount(
            [list[0].longitude, list[0].latitude],
            [list[1].longitude, list[1].latitude]
          );
          res.forEach((item, index) => {
            this.polyline.path.push([item.longitude, item.latitude]);
            if (index) {
              this.markers.push({
                label: {
                  offset: [-30, -25], //设置文本标注偏移量
                  content: `<div class="mapLabel">${item.title}</div>` //设置文本标注内容
                },
                image: require("@/assets/mapBoat.png"),
                position: [item.longitude, item.latitude],
                events: {
                  click() {
                    that.wind = [];
                    //选中当前maker跳动，其余不跳动
                    // that.markers.map(v=>v.animation = 'AMAP_ANIMATION_NONE');
                    // that.markers[0].animation = 'AMAP_ANIMATION_BOUNCE'
                    that.center = [item.longitude, item.latitude];
                    that.zoom = 9;
                  }
                }
              });
            } else {
              this.markers.push({
                label: {
                  offset: [-20, -25], //设置文本标注偏移量
                  content: `<div class="mapLabel">我的位置</div>` //设置文本标注内容
                },
                image: require("@/assets/mapBoatOwn.png"),
                position: [item.longitude, item.latitude],
                events: {
                  click() {
                    that.wind = [];
                    //选中当前maker跳动，其余不跳动
                    // that.markers.map(v=>v.animation = 'AMAP_ANIMATION_NONE');
                    // that.markers[0].animation = 'AMAP_ANIMATION_BOUNCE'
                    that.center = [item.longitude, item.latitude];
                    that.zoom = 9;
                  }
                }
              });
            }
          });
        })
        .catch(err => {
          this.$showError(err, "warn");
        });
    },
    refresh() {
      this.zoom = 6;
      this.getData(this.id);
    },
    getdiscount(p1, p2) {
      let lat1 = p1[0];
      let lng1 = p1[1];
      let lat2 = p2[0];
      let lng2 = p1[1];
      let radLat1 = (lat1 * Math.PI) / 180.0;
      let radLat2 = (lat2 * Math.PI) / 180.0;
      let a = radLat1 - radLat2;
      let b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
      let s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378.137; // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000;
      s = s * 1000;
      if (isNaN(s)) {
        return 0 + "m";
      }
      if (s > 1000) {
        //    大于1000米时
        s = Math.floor((s / 1000) * 100) / 100;
        s = s + "km";
      } else {
        //    小于1000米直接返回
        s = s + "m";
      }
      return s;
    }
  }
};
</script>
<style>
.appoint-map {
  width: 100%;
  height: 100vh;
}
.appoint-map .refresh {
  position: fixed;
  left: 20px;
  top: 20px;
  width: 60px;
  height: 60px;
  z-index: 9999;
}
.appoint-map .position-long {
  position: fixed;
  top: 20px;
  left: 100px;
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
  background: #fff;
  text-align: center;
  border: 1px solid #2476d1;
  z-index: 9999;
}
.appoint-map .amap-marker-label {
  border: none;
  color: #111;
}
.appoint-map .amap-icon img {
  width: 80px;
  height: 80px;
  margin-left: -24px;
}
</style>
